<div class="bg-preview-stage" #previewStage>
  <div
    class="bg-preview-canvas"
    [ngStyle]="canvasStyle"
    [style.transform]="canvasTransform"
  >
    <div class="bg-preview-logo" *ngIf="showLogo">
      <img *ngIf="logoUrl; else logoFallback" [src]="logoUrl" alt="" class="bg-preview-logo__img" />
      <ng-template #logoFallback>
        <div class="bg-preview-logo__placeholder"></div>
      </ng-template>
    </div>
    <div class="bg-preview-qr-wrap" *ngIf="hasQr">
      <span
        class="bg-preview-qr-label"
        *ngIf="qrLabel?.trim()"
        [style.fontFamily]="labelFontFamily"
        >{{ qrLabel }}</span
      >
      <qrcode
        [qrdata]="qrData || fallbackQrData"
        [width]="previewQrPx"
        [errorCorrectionLevel]="overlayQr.errorCorrectionLevel"
        [margin]="overlayQr.margin"
        [colorDark]="overlayQr.colorDark"
        [colorLight]="overlayQr.colorLight"
        cssClass="bg-preview-qr-code"
      ></qrcode>
    </div>
  </div>
  @if (loading) {
    <div class="bg-preview-overlay" aria-busy="true">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  }
</div>
